import { render, staticRenderFns } from "./ModelPublishSidebar.vue?vue&type=template&id=972eefb4&"
import script from "./ModelPublishSidebar.vue?vue&type=script&lang=ts&"
export * from "./ModelPublishSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ModelPublishSidebar.vue?vue&type=style&index=0&id=972eefb4&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/StratusCAD/ModelPipelineClient/model-pipeline-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('972eefb4')) {
      api.createRecord('972eefb4', component.options)
    } else {
      api.reload('972eefb4', component.options)
    }
    module.hot.accept("./ModelPublishSidebar.vue?vue&type=template&id=972eefb4&", function () {
      api.rerender('972eefb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modelPublish/ModelPublishSidebar.vue"
export default component.exports